<script setup>
import {defineProps} from 'vue';
import QuestDetails from "@/components/list/ContentListDetailsQuest";
import PathDetails from "@/components/list/ContentListDetailsPath";
import ComplainceDetails from "@/components/list/ContentListDetailsCompliance";

const props = defineProps({
    content: Object,
});

let showTitle = false;
if (props.content.quest_type_key === 'QUEST' || props.content.quest_type_key === 'PATH') {
    showTitle = true;
} else if (props.content.due_date && props.content.progress < 100) {
    showTitle = true;
}
</script>

<template>
    <div>
        <span v-if="showTitle" class="text-xs font-bold uppercase text-slate-700">{{ $tt('content_card__details_title') }}</span>
        <div class="mt-2 mb-3 flex flex-wrap lg:flex-nowrap space-x-2 rtl:space-x-reverse">
            <QuestDetails v-if="props.content.quest_type_key === 'QUEST'" :content="content"/>
            <PathDetails v-else-if="props.content.quest_type_key === 'PATH'" :content="content"/>
            <ComplainceDetails v-if="props.content.due_date && props.content.progress < 100" :content="content"/>
        </div>
    </div>
</template>
